import styled from 'styled-components';


const media = {

    tablet:
        '@media (max-width: 768px)',

    mobile:
        '@media (max-width: 520px)'

};


/*
====================================
CONTENEDOR GENERAL
====================================
*/

export const ContenedorActividadesDomicilio =
    styled.div`

        width:
            100%;

        padding:
            22px 44px 30px 44px;

        box-sizing:
            border-box;


        ${media.tablet} {

            padding:
                18px 20px 24px 20px;

        }


        ${media.mobile} {

            padding:
                14px 12px 20px 12px;

        }

    `;


/*
====================================
TABS PRINCIPALES
====================================
*/

export const TabsActividades =
    styled.div`

        width:
            100%;

        display:
            grid;

        grid-template-columns:
            repeat(
                3,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            4px;

        background:
            #EFEFEA;

        border-radius:
            12px;

        padding:
            4px;

        box-sizing:
            border-box;

        margin-bottom:
            22px;


        ${media.mobile} {

            grid-template-columns:
                1fr;

        }

    `;


/*
====================================
BOTÓN TAB
====================================
*/

export const TabActividad =
    styled.button`

        width:
            100%;

        border:
            none;

        border-radius:
            9px;

        padding:
            13px 12px;

        background:
            ${props =>
                props.activo
                    ? '#23AAAF'
                    : 'transparent'
            };

        color:
            ${props =>
                props.activo
                    ? '#FFFFFF'
                    : '#646464'
            };

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.02em;

        cursor:
            pointer;

        transition:
            background 0.15s ease,
            color 0.15s ease,
            box-shadow 0.15s ease;


        &:hover {

            background:
                ${props =>
                    props.activo
                        ? '#23AAAF'
                        : '#FFFFFF'
                };

        }


        ${media.mobile} {

            font-size:
                12px;

            padding:
                11px 10px;

        }

    `;


/*
====================================
ÁREA DE CONTENIDO
====================================
*/

export const PanelActividades =
    styled.div`

        width:
            100%;

        min-height:
            420px;

        box-sizing:
            border-box;

    `;

    /*
====================================
TODAS LAS ACTIVIDADES
====================================
*/

export const ContenedorDisponibles =
    styled.div`

        width:
            100%;

        display:
            flex;

        flex-direction:
            column;

        box-sizing:
            border-box;

    `;


/*
====================================
CATEGORÍAS PRINCIPALES
====================================
*/

export const CategoriasActividades =
    styled.div`

        width:
            100%;

        display:
            flex;

        align-items:
            center;

        gap:
            8px;

        flex-wrap:
            wrap;

        margin-bottom:
            14px;

    `;


export const BotonCategoriaActividad =
    styled.button`

        border:
            none;

        background:
            ${props =>
                props.activo
                    ? '#23AAAF'
                    : 'transparent'
            };

        color:
            ${props =>
                props.activo
                    ? '#FFFFFF'
                    : '#646464'
            };

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-weight:
            600;

        text-transform:
            uppercase;

        padding:
            10px 18px;

        border-radius:
            10px;

        cursor:
            pointer;

        transition:
            background 0.15s ease,
            color 0.15s ease;


        &:hover {

            background:
                ${props =>
                    props.activo
                        ? '#23AAAF'
                        : '#EFEFEA'
                };

        }

    `;


/*
====================================
LEYENDA
====================================
*/

export const LeyendaSeleccion =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            20px;

        flex-wrap:
            wrap;

        margin-bottom:
            14px;

        font-size:
            12px;

        color:
            #646464;

    `;


export const ItemLeyenda =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            7px;

    `;


export const PuntoLeyenda =
    styled.span`

        width:
            11px;

        height:
            11px;

        border-radius:
            50%;

        flex-shrink:
            0;

        background:
            ${props =>
                props.seleccionado
                    ? '#D76970'
                    : '#C7C7C2'
            };

    `;


/*
====================================
NAVEGADOR DE ACTIVIDADES
====================================
*/

export const NavegadorActividades =
    styled.div`

        width:
            100%;

        min-height:
            380px;

        display:
            grid;

        grid-template-columns:
            repeat(
                4,
                minmax(
                    180px,
                    1fr
                )
            );

        gap:
            18px;

        background:
            #FFFFFF;

        border:
            1.5px solid #EDEDE9;

        border-radius:
            16px;

        padding:
            24px;

        box-sizing:
            border-box;

        overflow-x:
            auto;


        ${media.tablet} {

            grid-template-columns:
                repeat(
                    2,
                    minmax(
                        220px,
                        1fr
                    )
                );

        }


        ${media.mobile} {

            grid-template-columns:
                1fr;

            padding:
                16px;

        }

    `;


/*
====================================
COLUMNA DE NAVEGACIÓN
====================================
*/

export const ColumnaNavegacion =
    styled.div`

        min-width:
            0;

        display:
            flex;

        flex-direction:
            column;

        gap:
            7px;

    `;


export const TituloColumnaActividad =
    styled.div`

        min-height:
            18px;

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.03em;

        margin-bottom:
            4px;

    `;


/*
====================================
BOTÓN DE NIVEL
====================================
*/

export const BotonNivelActividad =
    styled.button`

        width:
            100%;

        border:
            none;

        background:
            ${props =>
                props.activo
                    ? '#BFE0DF'
                    : 'transparent'
            };

        color:
            ${props =>
                props.activo
                    ? '#0E7A7E'
                    : '#2B2B2B'
            };

        text-align:
            left;

        padding:
            9px 10px;

        border-radius:
            8px;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            ${props =>
                props.activo
                    ? '600'
                    : '500'
            };

        cursor:
            pointer;

        transition:
            background 0.15s ease;


        &:hover {

            background:
                ${props =>
                    props.activo
                        ? '#BFE0DF'
                        : '#F8F8F6'
                };

        }

    `;


/*
====================================
EJERCICIO
====================================
*/

export const FilaEjercicio =
    styled.div`

        width:
            100%;

        display:
            flex;

        align-items:
            center;

        gap:
            10px;

        padding:
            9px;

        box-sizing:
            border-box;

        border-radius:
            10px;

        cursor:
            pointer;

        transition:
            background 0.15s ease;


        &:hover {

            background:
                #F8F8F6;

        }

    `;


export const MiniaturaEjercicio =
    styled.img`

        width:
            48px;

        height:
            34px;

        object-fit:
            cover;

        border-radius:
            8px;

        flex-shrink:
            0;

    `;


export const NombreEjercicio =
    styled.span`

        flex:
            1;

        min-width:
            0;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-weight:
            500;

        line-height:
            1.35;

    `;


export const IndicadorSeleccion =
    styled.button`

        width:
            14px;

        height:
            14px;

        min-width:
            14px;

        padding:
            0;

        border:
            none;

        border-radius:
            50%;

        background:
            ${props =>
                props.seleccionado
                    ? '#D76970'
                    : '#C7C7C2'
            };

        cursor:
            pointer;

    `;


export const SinContenidoActividad =
    styled.div`

        color:
            #B5B5B0;

        font-size:
            12px;

        padding:
            10px 4px;

    `;

    /*
====================================
ACTIVIDADES SELECCIONADAS
====================================
*/

export const ContenedorSeleccionadas =
    styled.div`

        width:
            100%;

        display:
            flex;

        flex-direction:
            column;

        box-sizing:
            border-box;

    `;


export const TituloSeleccionadas =
    styled.div`

        width:
            100%;

        padding-bottom:
            10px;

        margin-bottom:
            14px;

        border-bottom:
            1.5px solid #2B2B2B;

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.03em;

    `;


/*
====================================
LISTA
====================================
*/

export const ListaSeleccionadas =
    styled.div`

        width:
            100%;

        display:
            flex;

        flex-direction:
            column;

        gap:
            10px;

        box-sizing:
            border-box;

    `;


export const FilaSeleccionada =
    styled.div`

        width:
            100%;

        display:
            grid;

        grid-template-columns:
            minmax(
                220px,
                1fr
            )
            auto
            auto
            auto;

        align-items:
            center;

        gap:
            16px;

        padding:
            13px 16px;

        background:
            #F8F8F6;

        border-radius:
            12px;

        box-sizing:
            border-box;


        ${media.tablet} {

            grid-template-columns:
                1fr auto;

        }


        ${media.mobile} {

            grid-template-columns:
                1fr;

            gap:
                12px;

        }

    `;


export const NombreActividadSeleccionada =
    styled.div`

        min-width:
            0;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            500;

        line-height:
            1.4;

    `;


/*
====================================
ELIMINAR
====================================
*/

export const BotonEliminarSeleccionada =
    styled.button`

        border:
            1.5px solid #DDDDD8;

        background:
            #FFFFFF;

        color:
            #646464;

        padding:
            7px 14px;

        border-radius:
            16px;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        font-weight:
            600;

        cursor:
            pointer;

        transition:
            border-color 0.15s ease,
            color 0.15s ease;


        &:hover {

            border-color:
                #D76970;

            color:
                #D76970;

        }

    `;


/*
====================================
CANTIDAD
====================================
*/

export const ContadorActividad =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            8px;

    `;


export const BotonContador =
    styled.button`

        width:
            28px;

        height:
            28px;

        padding:
            0;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        border:
            1.5px solid #DDDDD8;

        border-radius:
            50%;

        background:
            #FFFFFF;

        color:
            #2B2B2B;

        font-size:
            16px;

        font-weight:
            600;

        cursor:
            pointer;


        &:hover {

            border-color:
                #23AAAF;

            color:
                #23AAAF;

        }

    `;


export const ValorContador =
    styled.span`

        width:
            24px;

        text-align:
            center;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

    `;


/*
====================================
ORDEN
====================================
*/

export const ControlesOrden =
    styled.div`

        display:
            flex;

        flex-direction:
            column;

        gap:
            2px;

    `;


export const BotonOrden =
    styled.button`

        width:
            28px;

        height:
            23px;

        padding:
            0;

        border:
            none;

        border-radius:
            5px;

        background:
            transparent;

        color:
            #23AAAF;

        font-size:
            14px;

        font-weight:
            600;

        cursor:
            pointer;


        &:hover {

            background:
                rgba(
                    35,
                    170,
                    175,
                    0.10
                );

        }

    `;


/*
====================================
SIN ACTIVIDADES
====================================
*/

export const SinActividadesSeleccionadas =
    styled.div`

        width:
            100%;

        padding:
            50px 10px;

        text-align:
            center;

        color:
            #646464;

        font-size:
            13px;

        box-sizing:
            border-box;

    `;


/*
====================================
BARRA DE AGENDADO
====================================
*/

export const BarraAgendado =
    styled.div`

        width:
            100%;

        display:
            flex;

        align-items:
            flex-end;

        gap:
            30px;

        flex-wrap:
            wrap;

        padding-top:
            18px;

        margin-top:
            18px;

        border-top:
            1.5px solid #EDEDE9;

        box-sizing:
            border-box;


        ${media.mobile} {

            align-items:
                stretch;

            gap:
                16px;

        }

    `;


export const CampoAgendado =
    styled.div`

        display:
            flex;

        flex-direction:
            column;

        gap:
            6px;

    `;


export const LabelAgendado =
    styled.label`

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            10px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.02em;

    `;


export const InputFechaAgendado =
    styled.input`

        min-height:
            38px;

        padding:
            8px 12px;

        border:
            1.5px solid #DDDDD8;

        border-radius:
            9px;

        background:
            #FFFFFF;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        outline:
            none;

        box-sizing:
            border-box;


        &:focus {

            border-color:
                #23AAAF;

        }

    `;


export const ValorAgendado =
    styled.div`

        min-height:
            38px;

        display:
            flex;

        align-items:
            center;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

    `;


export const BotonAgendarActividad =
    styled.button`

        margin-left:
            auto;

        min-height:
            42px;

        padding:
            11px 30px;

        border:
            none;

        border-radius:
            22px;

        background:
            #FC8906;

        color:
            #FFFFFF;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

        cursor:
            pointer;

        transition:
            opacity 0.15s ease;


        &:hover {

            opacity:
                0.88;

        }


        ${media.mobile} {

            width:
                100%;

            margin-left:
                0;

        }

    `;

    /*
====================================
ACTIVIDADES AGENDADAS
====================================
*/

export const ContenedorAgendadas =
    styled.div`

        width:
            100%;

        display:
            flex;

        flex-direction:
            column;

        box-sizing:
            border-box;

    `;


/*
====================================
BUSCADOR
====================================
*/

export const BuscadorAgendadas =
    styled.div`

        width:
            100%;

        max-width:
            380px;

        height:
            42px;

        display:
            flex;

        align-items:
            center;

        gap:
            8px;

        padding:
            0 14px;

        margin-bottom:
            16px;

        border:
            1.5px solid #DDDDD8;

        border-radius:
            10px;

        background:
            #FFFFFF;

        box-sizing:
            border-box;

    `;


export const IconoBuscarAgendadas =
    styled.span`

        color:
            #23AAAF;

        font-size:
            16px;

        line-height:
            1;

        flex-shrink:
            0;

    `;


export const InputBuscarAgendadas =
    styled.input`

        width:
            100%;

        height:
            100%;

        border:
            none;

        outline:
            none;

        background:
            transparent;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

    `;


/*
====================================
TABLA VISUAL
====================================
*/

export const TablaAgendadas =
    styled.div`

        width:
            100%;

        min-width:
            0;

        overflow-x:
            hidden;

    `;


export const EncabezadoAgendadas =
    styled.div`

        width:
            100%;

        min-width:
            0;

        display:
            grid;

        grid-template-columns:
            0.95fr
            0.95fr
            0.55fr
            0.95fr
            0.9fr
            1fr
            2.3fr;

        column-gap:
            14px;

        padding:
            0 12px 10px 12px;

        border-bottom:
            1.5px solid #2B2B2B;

        box-sizing:
            border-box;


        > div {

            min-width:
                0;

        }


        ${media.tablet} {

            column-gap:
                8px;

            padding:
                0 6px 8px 6px;

        }

    `;


export const TituloColumnaAgendada =
    styled.div`

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            10px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.02em;

    `;


export const ListaAgendadas =
    styled.div`

        width:
            100%;

        height:
            calc(
                100vh - 315px
            );

        min-height:
            280px;

        max-height:
            none;

        overflow-y:
            auto;

        overflow-x:
            hidden;


        &::-webkit-scrollbar {

            width:
                8px;

        }


        &::-webkit-scrollbar-thumb {

            background:
                #B5B5B0;

            border-radius:
                8px;

        }

    `;


export const FilaAgendada =
    styled.div`

        width:
            100%;

        min-width:
            0;

        display:
            grid;

        grid-template-columns:
            0.95fr
            0.95fr
            0.55fr
            0.95fr
            0.9fr
            1fr
            2.3fr;

        column-gap:
            14px;

        align-items:
            center;

        padding:
            12px;

        border-bottom:
            1px solid #EDEDE9;

        box-sizing:
            border-box;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;


        > div {

            min-width:
                0;

            overflow-wrap:
                anywhere;

        }


        &:nth-child(even) {

            background:
                #F8F8F6;

        }


        ${media.tablet} {

            column-gap:
                8px;

            padding:
                10px 6px;

            font-size:
                10px;

        }

    `;

export const LeccionAgendada =
    styled.div`

        color:
            #9A9A96;

        font-weight:
            500;

    `;


export const EjercitacionAgendada =
    styled.div`

        color:
            #2B2B2B;

        font-weight:
            500;

        line-height:
            1.45;

    `;


/*
====================================
ESTADO
====================================
*/

export const EstadoAgendada =
    styled.span`

        width:
            fit-content;

        display:
            inline-flex;

        align-items:
            center;

        justify-content:
            center;

        padding:
            5px 10px;

        border-radius:
            14px;

        background:
            ${props =>
                props.completo
                    ? '#2B2B2B'
                    : '#FBE6CE'
            };

        color:
            ${props =>
                props.completo
                    ? '#FFFFFF'
                    : '#E7973C'
            };

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            9px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.02em;

        white-space:
            nowrap;

    `;


/*
====================================
SIN RESULTADOS
====================================
*/

export const SinAgendadas =
    styled.div`

        width:
            100%;

        padding:
            50px 10px;

        text-align:
            center;

        color:
            #646464;

        font-size:
            13px;

        box-sizing:
            border-box;

    `;